import { useState } from "react";
import DropdownMenu from "../DropdownMenu/DropdownMenu";

const SetEditor = (props) => {
  const [set, setSet] = useState(props.exerciseSet);

  const handleSetWeightChange = (event) => {
    setSet({
      ...set,
      weight: event.target.value,
    });
  };

  const handleSetWeightAndRepsBlur = () => {
    props.onSetDetailsUpdate(set);
  };

  const handleSetRepsChange = (event) => {
    setSet({
      ...set,
      reps: event.target.value,
    });
  };

  return (
    <div className={`flex flex-row relative ${props.className}`}>
      <span className="block text-sm font-medium text-gray-700 mr-1">
        {`${props.order}.`}
      </span>
      <div className="-space-y-px rounded-md grid grid-cols-[1fr_1fr] gap-x-2 mr-3.5 w-full">
        <div>
          <label
            htmlFor={`set-weight-${props.order}`}
            className="block text-sm font-medium text-gray-700"
          >
            Weight
          </label>
          <input
            id={`set-weight-${props.order}`}
            name={`set-weight-${props.order}`}
            type="text"
            inputMode="decimal"
            autoComplete="off"
            required
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
            value={set.weight || ""}
            onChange={handleSetWeightChange}
            onBlur={handleSetWeightAndRepsBlur}
            tabIndex={-1}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
          />
        </div>
        <div>
          <label
            htmlFor={`set-reps-${props.order}`}
            className="block text-sm font-medium text-gray-700"
          >
            Reps
          </label>
          <input
            id={`set-reps-${props.order}`}
            name={`set-reps-${props.order}`}
            type="text"
            inputMode="decimal"
            autoComplete="off"
            required
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
            value={set.reps || ""}
            onChange={handleSetRepsChange}
            onBlur={handleSetWeightAndRepsBlur}
            tabIndex={-1}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
          />
        </div>
        <div className="absolute right-[-4px] top-[-4px]">
          <DropdownMenu
            menuItems={["Delete"]}
            onDeleteClicked={props.onDeleteSet}
            parentId={set._id}
          />
        </div>
      </div>
    </div>
  );
};

export default SetEditor;
